import React from 'react';
import BlazeInputDropdown, {
  BlazeDropdownItem,
} from '../../../../components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { SecretsVault } from '../../../../types/rest/mockServiceTypes';

export const defaultSecretsVault: BlazeDropdownItem = {
  id: null,
  name: ' Use Internal Vault',
};

export const noExistingSecretsVault: BlazeDropdownItem = {
  id: '-1',
  name: '',
};

interface Props {
  id: any;
  secretsVaultList: SecretsVault[];
  /** Current Secret Vault selected */
  selectedSecretsVaultId: number | null;
  /** On Change handler */
  onChangeSecretsVault: (secretsVaultId: number | null) => void;
  disabled?: boolean;
}

/** Converts id of selected configuration to BlazeDropdownItem */
export const getSelectedItem = (selectedSecretsVaultId: any, secretsVaultItems: SecretsVault[]): BlazeDropdownItem => {
  if (selectedSecretsVaultId === null || selectedSecretsVaultId === undefined) {
    return defaultSecretsVault;
  }
  const config: BlazeDropdownItem =
    secretsVaultItems
      .map(item => ({ id: item.id, name: item.integrationName }))
      .find(item => item.id === selectedSecretsVaultId) || noExistingSecretsVault;
  return config ? config : noExistingSecretsVault;
};

const SecretsVaultDropdown = (props: Props) => {
  const selectSecretsVaultHandler = (item: BlazeDropdownItem) => {
    props.onChangeSecretsVault(item.id as number);
  };

  const secretsVaultItems: BlazeDropdownItem[] = [
    defaultSecretsVault,
    ...props.secretsVaultList.map(cg => ({
      id: cg.id,
      name: cg.integrationName,
    })),
  ];

  return (
    <>
      <label className={'mt-2'} htmlFor={'selectSecretsDropdown'}>
        Vault Integration:
      </label>
      <span>
        <div style={{ maxWidth: '232px' }}>
          <BlazeInputDropdown
            id={'secret-vault-picker-' + props.id}
            minDropdownMenuWidth={230}
            isDefaultOptionSelectable={false}
            defaultOption={noExistingSecretsVault}
            onClick={selectSecretsVaultHandler}
            selected={getSelectedItem(props.selectedSecretsVaultId, props.secretsVaultList)}
            items={secretsVaultItems}
          />
        </div>
        {getSelectedItem(props.selectedSecretsVaultId, props.secretsVaultList).id === '-1' && (
          <div className="small mt-2 text-danger">
            Previously value selected does not longer exist, please select another one.
          </div>
        )}
      </span>
    </>
  );
};

export default SecretsVaultDropdown;
